var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.96 10.83-1.676 1.68c-.68.682-1.874.697-2.568 0L7.04 10.83l-6.017 6.036c.224.103.471.165.734.165h16.484c.263 0 .51-.061.733-.165L12.96 10.83Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.242 2.969H1.758c-.263 0-.51.062-.734.165l6.43 6.45v.001l.001.001 2.09 2.097c.222.223.687.223.91 0l2.09-2.096v-.002h.002l6.428-6.45a1.74 1.74 0 0 0-.733-.166ZM.187 3.953A1.736 1.736 0 0 0 0 4.726v10.547c0 .279.071.539.187.773L6.214 10 .187 3.953ZM19.813 3.953 13.787 10l6.026 6.046c.116-.234.187-.494.187-.773V4.726c0-.279-.07-.539-.187-.773Z",
    fill: "#fff"
  })));
};
export default SvgEmail;